function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Meldingen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1440px---Meldingen-algemeen",
  transform: "translate(-1240.000000, -406.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rows-tabel/Normaal/uitgeklap-status-opgelost",
  transform: "translate(120.000000, 396.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Asset-klaar",
  transform: "translate(1120.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  fill: "#9CE450",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,8.93416331 L8.9957757,12.5333333 C10.7941688,10.0201853 12.4622436,8.24240748 14,7.2",
  id: "Path-2-Copy",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9185825A-226C-4943-958C-97351ACEB7CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/Green_checkmark.8343b722165c19a162a198516f6aa5c0.svg";
export { ForwardRef as ReactComponent };